<template>
    <!-- variables: active, isDisabled, completed, invalid, pending -->
    <a
        href=""
        :tabindex="isDisabled ? -1 : 0"
        role="tab"
        :aria-selected="active"
        @click.prevent="select"
        @keypress.enter.space.prevent="select"
    >

        <div class="tw-flex tw-space-x-4 tw-bg-white tw-rounded-full">
            <!-- Active Step -->
            <div v-if="active"
                class="tw-active tw-relative tw-flex tw-items-center tw-justify-center tw-bg-white tw-border-2 tw-border-blue-800 tw-rounded-full tw-w-8 tw-h-8"
                aria-current="step">
                <span class="tw-h-2.5 tw-w-2.5 tw-bg-blue-800 tw-rounded-full" aria-hidden="true"></span>
            </div>

            <!-- Completed Step -->
            <div v-else-if="completed"
                 class="tw-completed tw-relative tw-flex tw-items-center tw-justify-center tw-bg-green-600 tw-rounded-full tw-w-8 tw-h-8">
                <svg class="tw-w-5 tw-h-5 tw-text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                     fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clip-rule="evenodd"></path>
                </svg>
            </div>

            <!-- Disabled Step -->
            <div v-else-if="isDisabled"
                 class="tw-disabled tw-relative tw-flex tw-items-center tw-justify-center tw-bg-white border-2 tw-border-gray-300 tw-rounded-full tw-w-8 tw-h-8 hover:tw-border-gray-400">
                <span class="tw-h-2 tw-w-2 tw-bg-transparent tw-rounded-full group-hover:tw-bg-gray-300" aria-hidden="true"></span>
            </div>

            <!-- Default Step (if none of the conditions are met) -->
            <div v-else
                 class="tw-disabled tw-relative tw-flex tw-items-center tw-justify-center tw-bg-white tw-border-2 tw-border-gray-300 tw-rounded-full tw-w-8 tw-h-8 hover:tw-border-gray-400">
                <span class="tw-h-2 tw-w-2 tw-bg-white tw-rounded-full" aria-hidden="true"></span>
            </div>

            <div class="tw-completed-line"
                 :style="{ width: ((this.step$.index + 1) * 100 / (Object.keys(this.steps$.steps).length - 1)) + '%' }"
                 :class="{'tw-completed-line tw-visible': completed}">
            </div>

        </div>

    </a>

</template>

<script>
export default {
    name: 'FormStep',
    data() {
        return {
            merge: true,
            defaultClasses: {
                container: '',
                wrapper: '',
            },
        }
    }
}
</script>

<style lang="scss">
</style>
